var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LogoSlogan bg-primary-darkest px-12 py-10 lg:py-20"},[_c('div',{staticClass:"flex justify-center flex-col items-center text-white mb-10"},[_c('JoszakiLogo',{attrs:{"sizing":"slogan"}}),_c('p',{staticClass:"mt-4 text-center font-bold text-2xl xl:text-4xl"},[_vm._v(" "+_vm._s(_vm.$t("branding.slogan"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }